function AnalyticsPage() {
  return (
    <div>
      <div>📈 Sales Reports & Charts are under production</div>
    </div>
  );
}

export default AnalyticsPage;
